const selectors = {
    content: '[data-content]',
    contentContainer: '[data-content-container]',
    scrollTo: '[data-scroll-to]',
    scrollToEl: (id) => `[data-scroll-id="${id}"]`,
    button: '[data-toggle-button]',
    wrap: '[data-toggle-wrap]',
    body: '[data-toggle-body]',
    open: '[data-toggle-open]',
    close: '[data-toggle-close]'
};
renderContentListTable();

function renderContentListTable() {
    const content = document.querySelector(selectors.content);

    if (!content) return;
    const contentContainer = content.querySelector(selectors.content);
    const titles = Array.from(content.children).filter(el => el.tagName === 'H2' || el.tagName === 'H3');
    console.log(contentContainer, content.children)

    if (!titles) return;

    const contentListBody = document.createElement("div"),
        contentList = document.createElement("div");
    const contentListWrapper = document.createElement("div");
    contentList.append(contentListWrapper);
    contentListWrapper.classList.add('table-of-contents__wrapper');
    contentListBody.setAttribute('data-toggle-body', '');
    contentListBody.classList.add('table-of-contents__body');
    contentListBody.classList.add('active');
    contentList.classList.add('table-of-contents');
    contentList.classList.add('active');
    contentList.setAttribute('data-toggle-wrap', '');
    contentList.setAttribute('data-content-list', '');
    const contentListHeader = document.createElement("header");
    contentListHeader.setAttribute('data-content-header', '');
    contentListHeader.classList.add('table-of-contents__header')
    contentListWrapper.append(contentListHeader);
    contentListHeader.innerHTML = `<h3>Table of contents</h3>
        <button data-toggle-hide="Hide" data-toggle-open="Open" data-toggle-button class="button button--transparent button--small active">
            <span>Hide</span>    
            <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="https://www.w3.org/2000/svg">
                <path d="M9.70292 6.99976L5.5 2.67137L1.29708 6.99976L0 5.66395L5.5 -0.000244141L11 5.66395L9.70292 6.99976Z" fill="#C19C64"/>
            </svg>
            
        </button>`;

    let firstIndex = titles.findIndex(el => el.tagName == 'H2');
    if (firstIndex > -1) {
        var html = '<ul class="table-of-contents__list">';
        for (var i = firstIndex + 1; i <= titles.length - 1; i++) {
            if (titles[i].tagName == 'H2') {
                titles[firstIndex].id = "heading-" + firstIndex;
                let temporary = titles.slice(firstIndex, i);
                html += `<li class="table-of-contents__list-item"><a href="#heading-${firstIndex}">${titles[firstIndex].innerText}</a></li>`
                firstIndex = i;
            }
            if (i === (titles.length - 1) && firstIndex > -1) {
                titles[firstIndex].id = "heading-" + firstIndex;
                const li = document.createElement("li");
                let temporary = titles.slice(firstIndex, titles.length)
                html += `<li class="table-of-contents__list-item"><a href="#heading-${firstIndex}">${titles[firstIndex].innerText}</a></li>`
            }
        }
        html += '</ul>';
        contentListBody.innerHTML = html;
        contentListWrapper.appendChild(contentListBody)

        contentContainer ? contentContainer.append(contentList) : content.prepend(contentList)
    }
    document.addEventListener('click', event => {
        const {target} = event;

        if (target.matches(selectors.scrollTo)) {
            event.preventDefault();
            const id = target.getAttribute('data-scroll-to');
            const scrollToEl = document.querySelector(selectors.scrollToEl(id));
            const offset = window.innerWidth < 1450 ? contentListHeader.offsetHeight + 250 : 0;
            window.scrollTo({
                top: scrollToEl.offsetTop - offset,
                behavior: 'smooth'
            });
        }
    })
    var lastScrollTop = 0,
        scrollDirection;
    window.addEventListener('scroll', function (event) {
        var st = this.scrollY;
        if (st > lastScrollTop) {
            scrollDirection = 'down'
        } else {
            scrollDirection = 'up'
        }

        if (contentList.getBoundingClientRect().bottom < -175) {
            contentList.style.height = contentList.offsetHeight + 'px';
            contentList.classList.add('sticky')
        } else if (contentList.getBoundingClientRect().bottom > -175) {

            contentList.classList.remove('sticky');
            contentList.style.height = 'auto';

        }
        if (content.getBoundingClientRect().bottom < contentListWrapper.getBoundingClientRect().bottom && contentList.classList.contains('sticky') && scrollDirection == 'down') {
            content.style.position = 'relative'
            contentListWrapper.style.bottom = 0;
            contentListWrapper.style.top = 'auto';
            contentListWrapper.style.position = 'absolute';
        } else if (contentListWrapper.getBoundingClientRect().top >= 120 && contentList.classList.contains('sticky') && scrollDirection == 'up') {
            content.style.position = '';
            contentListWrapper.style.bottom = '';
            contentListWrapper.style.top = '';
            contentListWrapper.style.position = '';
        }
        lastScrollTop = st <= 0 ? 0 : st;
    });
    window.addEventListener('resize', event => {
        if (window.innerWidth < 1400) {
            contentList.style.height = '';
            contentList.classList.remove('sticky')
        }
    })
}

function renderInnerElement(temporary, i) {
    if (!temporary.length) return ``;
    const subtitles = temporary.filter(el => el.tagName === 'H3');
    if (!subtitles.length) return ``;
    return `<div class="table-of-contents__dropdown"><ul> ${subtitles.map((el, index) => {
        el.setAttribute('data-scroll-id', `${i}-${index}`);
        return `<li><a data-scroll-to="${i}-${index}" href="#">${el.innerText}</a></li>`
    })}</ul></div>`;
}

const toggleElement = (element) => {
    const open = element.getAttribute('data-toggle-open');
    const close = element.getAttribute('data-toggle-hide');
    const wrap = element.closest(selectors.wrap);
    const body = wrap ? wrap.querySelector(selectors.body) : undefined;
    const text = element.querySelector('span');

    element.classList.toggle('active');
    wrap ? wrap.classList.toggle('active') : '';
    body ? body.classList.toggle('active') : '';
    if (!open || !close || !text) return;
    console.log(element)
    element.classList.contains('active') ? text.innerText = close : text.innerText = open;
};

document.addEventListener('click', (event) => {
    const target = event.target;
    if (target.matches(`${selectors.button}, ${selectors.button} *`)) {
        event.preventDefault();
        const element = target.matches(selectors.button) ? target : target.closest(selectors.button);
        toggleElement(element);
    }
});

// This code below fixes an issue where a heading is hidden by a sticky header, and it enables smooth scrolling to display the heading.
let links = document.querySelectorAll('.table-of-contents__list a');
let lastScrollPos = window.scrollY;

links.forEach(function (link) {
    link.addEventListener('click', function (e) {
        e.preventDefault(); // Prevent the default link behavior

        let href = this.getAttribute('href'); // Get the target section ID
        let target = document.querySelector(href); // Find the target section

        if (target) {
            let targetOffset = target.getBoundingClientRect().top + window.scrollY;
            // Determine the scroll direction and adjust the target position
            if (lastScrollPos > targetOffset) {
                window.scrollTo({
                    top: targetOffset - 140,
                    behavior: 'smooth'
                });
            } else {
                target.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
    });
});

window.addEventListener('scroll', function () {
    lastScrollPos = window.scrollY;
});


// Sticky Share Icons in Single Blog
let hasSeenFooter = false;

function isElementInViewport(el, offset = 0) {
    var rect = el.getBoundingClientRect();
    return rect.top - offset <= window.innerHeight && rect.bottom >= 0;
}

function checkFooterVisibility() {
    const footer = document.querySelector('.insight-item__categories');

    if (isElementInViewport(footer, -280) && !hasSeenFooter) {
        document.querySelector('.share-list').classList.add('-absolute');
        hasSeenFooter = true; // Set the variable to true to indicate the footer has been seen
    } else if (!isElementInViewport(footer, -280) && hasSeenFooter) {
        document.querySelector('.share-list').classList.remove('-absolute');
        hasSeenFooter = false; // Set the variable to false to indicate the footer is no longer in the viewport
    }
}

// window.addEventListener('scroll', checkFooterVisibility);
// window.addEventListener('resize', checkFooterVisibility);

// // Call the function initially when the page loads
// document.addEventListener('DOMContentLoaded', checkFooterVisibility);
